/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import './landing.css';
import './skeleton.css';

import styled from 'styled-components';


import {
  Container, Grid, Card
} from 'tabler-react';

const LandingContainer = styled.div`
h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 2rem;
  font-weight: 300; }
h1 { font-size: 4.0rem; line-height: 1.2;  letter-spacing: -.1rem;}
h2 { font-size: 3.6rem; line-height: 1.25; letter-spacing: -.1rem; }
h3 { font-size: 3.0rem; line-height: 1.3;  letter-spacing: -.1rem; }
h4 { font-size: 2.4rem; line-height: 1.35; letter-spacing: -.08rem; }
h5 { font-size: 1.8rem; line-height: 1.5;  letter-spacing: -.05rem; }
h6 { font-size: 1.5rem; line-height: 1.6;  letter-spacing: 0; }*/

/* Larger than phablet */
@media (min-width: 550px) {
  h1 { font-size: 5.0rem; }
  h2 { font-size: 4.2rem; }
  h3 { font-size: 3.6rem; }
  h4 { font-size: 3.0rem; }
  h5 { font-size: 2.4rem; }
  h6 { font-size: 1.5rem; }
}
line-height: 1.6;
font-weight: 400;
font-family: "Raleway", "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
color: #222;
button,
.button {
  margin-bottom: 1rem; }
input,
textarea,
select,
fieldset {
  margin-bottom: 1.5rem; }
pre,
blockquote,
dl,
figure,
table,
p,
ul,
ol,
form {
  margin-bottom: 2.5rem
}
`;

export default () => (
  <LandingContainer>
    <svg
      style={{
        position: 'absolute', width: 0, height: 0, overflow: 'hidden',
      }}
      version="1.1"
    >
      <defs>
        <symbol id="icon-appleinc" viewBox="0 0 32 32">
          <title>appleinc</title>
          <path d="M24.734 17.003c-0.040-4.053 3.305-5.996 3.454-6.093-1.88-2.751-4.808-3.127-5.851-3.171-2.492-0.252-4.862 1.467-6.127 1.467-1.261 0-3.213-1.43-5.28-1.392-2.716 0.040-5.221 1.579-6.619 4.012-2.822 4.897-0.723 12.151 2.028 16.123 1.344 1.944 2.947 4.127 5.051 4.049 2.026-0.081 2.793-1.311 5.242-1.311s3.138 1.311 5.283 1.271c2.18-0.041 3.562-1.981 4.897-3.931 1.543-2.255 2.179-4.439 2.216-4.551-0.048-0.022-4.252-1.632-4.294-6.473zM20.705 5.11c1.117-1.355 1.871-3.235 1.665-5.11-1.609 0.066-3.559 1.072-4.713 2.423-1.036 1.199-1.942 3.113-1.699 4.951 1.796 0.14 3.629-0.913 4.747-2.264z" />
        </symbol>
        <symbol id="icon-android" viewBox="0 0 32 32">
          <title>android</title>
          <path d="M28 12c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2s2-0.9 2-2v-8c0-1.1-0.9-2-2-2zM4 12c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2s2-0.9 2-2v-8c0-1.1-0.9-2-2-2zM7 23c0 1.657 1.343 3 3 3v0 4c0 1.1 0.9 2 2 2s2-0.9 2-2v-4h4v4c0 1.1 0.9 2 2 2s2-0.9 2-2v-4c1.657 0 3-1.343 3-3v-11h-18v11z" />
          <path d="M24.944 10c-0.304-2.746-1.844-5.119-4.051-6.551l1.001-2.001c0.247-0.494 0.047-1.095-0.447-1.342s-1.095-0.047-1.342 0.447l-1.004 2.009-0.261-0.104c-0.893-0.297-1.848-0.458-2.84-0.458s-1.947 0.161-2.84 0.458l-0.261 0.104-1.004-2.009c-0.247-0.494-0.848-0.694-1.342-0.447s-0.694 0.848-0.447 1.342l1.001 2.001c-2.207 1.433-3.747 3.805-4.051 6.551v1h17.944v-1h-0.056zM13 8c-0.552 0-1-0.448-1-1s0.447-0.999 0.998-1c0.001 0 0.002 0 0.003 0s0.001-0 0.002-0c0.551 0.001 0.998 0.448 0.998 1s-0.448 1-1 1zM19 8c-0.552 0-1-0.448-1-1s0.446-0.999 0.998-1c0 0 0.001 0 0.002 0s0.002-0 0.003-0c0.551 0.001 0.998 0.448 0.998 1s-0.448 1-1 1z" />
        </symbol>
      </defs>
    </svg>
    <Container>
      <Grid.Row cards className="my-8 py-8">
        <Grid.Col className="d-flex align-items-center justify-content-center" lg={6}>
          <Card>
            <Card.Body>
              <h4 className="hero-heading">Struggling to find items on BidFTA?</h4>
              <h5 className="hero-subheading">Maybe you just need a search box.</h5>
              <a className="button button-primary button-large" href="https://play.google.com/store/apps/details?id=com.ftakit&utm_source=Website-Landing">
Try FT Search - Android!
                <svg style={{ color: '#FFF' }} className="landing-icon icon-android"><use href="#icon-android" /></svg>
              </a>
              <a className="button button-primary button-large" href="https://itunes.apple.com/app/apple-store/id1168501703?pt=118442364&ct=Website-Landing&mt=8">
Try FT Search - iOS
                <svg style={{ color: '#FFF' }} className="landing-icon icon-appleinc"><use href="#icon-appleinc" /></svg>
              </a>
            </Card.Body>
          </Card>
        </Grid.Col>
        <Grid.Col lg={6} className="d-flex align-items-center justify-content-center">
          <img className="phone" src={require('./images/feature-1.png')} />
          <img className="phone" src={require('./images/feature-2.png')} />
        </Grid.Col>
      </Grid.Row>
    </Container>
    <Container>
      <Grid.Row cards className="py-8 my-8">
        <Grid.Col className="fb-100" lg={6}>
          <img className="" src={require('./images/email.png')} />
        </Grid.Col>
        <Grid.Col className="fb-100" lg={6}>
          <Card>
            <Card.Body>
              <h4 className="hero-heading">Get Daily Emails on items you are interested in.</h4>
              <h5 className="hero-subheading">Free for a limited time</h5>
              <a className="button button-primary button-large" href="/register">Sign up now</a>
            </Card.Body>
          </Card>
        </Grid.Col>
      </Grid.Row>
    </Container>
    <div className="section values">
      <div className="container">
        <div className="row">
          <div className="two-thirds column value">
            <h2 className="value-multiplier">Search</h2>
            <h5 className="value-heading">For items across the entire platform</h5>
            <p className="value-description">Full text search finds items you burried in the nooks and crannies.</p>
          </div>
          <div className="one-third column">
            <img className="u-max-full-width" src={require('./images/search.png')} />
          </div>
        </div>
      </div>
    </div>
    <div className="section values values-2">
      <div className="container">
        <div className="row">
          <div className="two-thirds column value float-right-desktop">
            <h2 className="value-multiplier">Filter</h2>
            <h5 className="value-heading">To see only the location you visit</h5>
            <p className="value-description">Save time by browsing through only the items you can pick up.</p>
          </div>
          <div className="one-third column">
            <img className="u-max-full-width" src={require('./images/filter.png')} />
          </div>
        </div>
      </div>
    </div>
    <div className="section values-3">
      <div className="container">
        <div className="row">
          <div className="two-thirds column value">
            <h2 className="value-multiplier">Watch</h2>
            <h5 className="value-heading">For items you don't want to lose</h5>
            <p className="value-description">Get notified when items you are interested in are ending.</p>
          </div>
          <div className="one-third column">
            <img className="u-max-full-width" src={require('./images/watch.png')} />
          </div>
        </div>
      </div>
    </div>

    <div className="section get-help">
      <div className="container">
        <a className="button button-primary button-large" href="/search">Continue to FtaKit</a>
        <h3 className="section-heading">Fan or Hate Mail?</h3>
        <p className="section-description">We would love to hear from you!</p>
        <a className="button button-primary" href="mailto:support@bidft.auction">Email Us</a>
      </div>
    </div>
  </LandingContainer>
);



// WEBPACK FOOTER //
// ./src/landing/index.js